// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
p,
ol,
ul,
li,
dl,
dt,
dd,
blockquote,
figure,
fieldset,
legend,
textarea,
pre,
iframe,
hr,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 400;
}

ul {
  list-style: none;
}

button,
input,
select,
textarea {
  margin: 0;
}

html {
  box-sizing: border-box;
}

*,
::before,
::after {
  box-sizing: inherit;
}

img,
embed,
iframe,
object,
video {
  height: auto;
  max-width: 100%;
}

audio {
  max-width: 100%;
}

iframe {
  border: 0;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

td,
th {
  padding: 0;
}

td:not([align]),
th:not([align]) {
  text-align: left;
}

html {
  /* background-color: #f8f8f8; */
  background-color: #fff;
  font-size: 16px;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  min-width: 300px;
  overflow-x: hidden;
  text-rendering: optimizeLegibility;
  text-size-adjust: 100%;
}

/* Chrome */
*:not(.enableScrollbar)::-webkit-scrollbar {
  width: 0;
  height: 0;
}

/* Firefox only */
*:not(.enableScrollbar) {
  scrollbar-width: none;
}

article,
aside,
figure,
footer,
header,
hgroup,
section {
  display: block;
}

body,
button,
input,
select,
textarea {
  font-family: "Nunito", sans-serif;
}

code,
pre {
  -moz-osx-font-smoothing: auto;
  -webkit-font-smoothing: auto;
  font-family: monospace;
}

body {
  color: #4a4a4a;
  font-size: 1em;
  font-weight: 400;
  line-height: 1.5;
}

a {
  color: #3273dc;
  cursor: pointer;
  text-decoration: none;
}
a strong {
  color: currentColor;
}
a:hover {
  color: #363636;
}

code {
  background-color: #f5f5f5;
  color: #ff3860;
  font-size: 0.875em;
  font-weight: 400;
  padding: 0.25em 0.5em;
}

hr {
  background-color: rgba(24, 28, 33, 0.24);
  border: none;
  display: block;
  height: 1px;
  margin: 0.5rem 0;
}

img {
  height: auto;
  max-width: 100%;
}

input[type=checkbox], input[type=radio] {
  vertical-align: baseline;
}

small {
  font-size: 0.875em;
}

span {
  font-style: inherit;
  font-weight: inherit;
}

strong {
  color: #363636;
  font-weight: 700;
}

pre {
  -webkit-overflow-scrolling: touch;
  background-color: #f5f5f5;
  color: #4a4a4a;
  font-size: 0.875em;
  overflow-x: auto;
  padding: 1.25rem 1.5rem;
  white-space: pre;
  word-wrap: normal;
}
pre code {
  background-color: transparent;
  color: currentColor;
  font-size: 1em;
  padding: 0;
}

table td,
table th {
  vertical-align: top;
}
table td:not([align]) {
  text-align: left;
}
table th {
  color: #363636;
}
table th:not([align]) {
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./packages/dre-magi-translate/frontend/src/assets/css/reset.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;EAuBE,SAAA;EACA,UAAA;AACF;;AAEA;;;;;;EAME,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;;;;EAIE,SAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;;;EAGE,mBAAA;AACF;;AAEA;;;;;EAKE,YAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,yBAAA;EACA,iBAAA;AACF;;AAEA;;EAEE,UAAA;AACF;;AAEA;;EAEE,gBAAA;AACF;;AAEA;EACE,+BAAA;EACA,sBAAA;EACA,eAAA;EACA,kCAAA;EACA,mCAAA;EACA,gBAAA;EACA,kBAAA;EAEA,kCAAA;EACA,sBAAA;AAAF;;AAGA,WAAA;AACA;EACE,QAAA;EACA,SAAA;AAAF;;AAGA,iBAAA;AACA;EACE,qBAAA;AAAF;;AAGA;;;;;;;EAOE,cAAA;AAAF;;AAGA;;;;;EAKE,iCAAA;AAAF;;AAGA;;EAEE,6BAAA;EACA,4BAAA;EACA,sBAAA;AAAF;;AAGA;EACE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,cAAA;EACA,eAAA;EACA,qBAAA;AAAF;AAEE;EACE,mBAAA;AAAJ;AAGE;EACE,cAAA;AADJ;;AAKA;EACE,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AAFF;;AAKA;EACE,wCAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;AAFF;;AAKA;EACE,YAAA;EACA,eAAA;AAFF;;AAME;EAEE,wBAAA;AAJJ;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,mBAAA;EACA,oBAAA;AALF;;AAQA;EACE,cAAA;EACA,gBAAA;AALF;;AAQA;EACE,iCAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AALF;AAOE;EACE,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;AALJ;;AAUE;;EAEE,mBAAA;AAPJ;AAUE;EACE,gBAAA;AARJ;AAWE;EAKE,cAAA;AAbJ;AASI;EACE,gBAAA;AAPN","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
